import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import {
  getCoderProviders,
  getCoderSystem,
  getCoderSystemStatus,
  type CoderProviderResponse,
  type CoderSystemConfigResponse,
  type CoderSystemStatusResponse,
} from "./api";

// Хуки секции «Система-кодер» (R55). Org-scoped запросы (см.
// `src/query/scope.ts`), `retry: false` — на 401/5xx повторяем по
// кнопке, не сами.
//
// Три источника:
// - `/providers` — статический каталог (radio + install-hint);
// - `/status` — probe наличия бинарей (он же rescan при refetch);
// - `/coder-system` — текущий per-org выбор; `coder_kind` может быть
//   `null` (кодер не выбран).

export function useCoderProviders(): UseQueryResult<
  readonly CoderProviderResponse[],
  Error
> {
  return useOrgScopedQuery<readonly CoderProviderResponse[]>({
    key: ["connections", "coder-system", "providers"],
    queryFn: () => getCoderProviders(),
    retry: false,
  });
}

export function useCoderSystemStatus(): UseQueryResult<
  CoderSystemStatusResponse,
  Error
> {
  return useOrgScopedQuery<CoderSystemStatusResponse>({
    key: ["connections", "coder-system", "status"],
    queryFn: () => getCoderSystemStatus(),
    retry: false,
  });
}

/** Смысловая часть ключа кэша выбора кодера (без скоуп-сегмента). */
export const CODER_SYSTEM_CHOICE_KEY = [
  "connections",
  "coder-system",
  "choice",
] as const;

export function useCoderSystemChoice(): UseQueryResult<
  CoderSystemConfigResponse,
  Error
> {
  return useOrgScopedQuery<CoderSystemConfigResponse>({
    key: CODER_SYSTEM_CHOICE_KEY,
    queryFn: () => getCoderSystem(),
    retry: false,
  });
}
